import React, {useState, useEffect, useContext} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { history } from '../../_helpers';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';


function ComSingleRa(){
  const [state, actions] = useContext(UserContext);
  const [ra, setRa] = useState()
  const [applicant, setApplicant] = useState()
  const [viewers, setViewers] = useState()
  const [which, setWhich] = useState()
  
  let user = JSON.parse(String(localStorage.getItem('user')))
  const header = {Authorization: `JWT ${user.token}`}

  // console.log(history.location.pathname.split('/')[3])
  const [editorToHtml, setEditorToHtml] = useState(EditorState.createEmpty())

  let apilink = ''

  if(localStorage.getItem("is_headhunter") === "true") {apilink = "/api/rahh/?id=";}
  else if (localStorage.getItem("is_recruiter") === "true") {apilink = "/api/ra/?id=";}
  
  
  if(history.location.pathname.split('/').length === 6) {
    apilink = "/api/" + history.location.pathname.split('/')[5] + "/?id=";
  }

  async function fetchRa(){
    const res =  fetch(state.awslink + apilink + history.location.pathname.split('/')[3], {
    method: 'GET',
    headers: header,
    })
    .then(response => response.json())
    .then(json=>{
      console.log(json)
      setApplicant(json.applicant)
      setViewers(json.views)
      delete json.applicant
      delete json.views

      let parsed = EditorState.createWithContent(convertFromRaw(JSON.parse(json.description))) 
      setEditorToHtml(draftToHtml(convertToRaw(parsed.getCurrentContent())))

      setRa(json)
      if(json.status === "HH") setWhich("headhunter")
      else setWhich("recruiter")
    }
    )
  }

  function fetchPostRashop(){
    fetch(state.awslink + "/user/rashop/", {
    method: 'POST',
    headers: header,
    body:JSON.stringify({
      "id": ra.id,
      "which": which,
    })
    })
    .then(response => response.json())
    .then(json=>{
      console.log(json)
    })
  }

  useEffect(()=>{
    // if(ra === null){
      // if(state.token !== undefined)
    
    fetchRa();
    // }
  }, [])

  console.log(ra, applicant, viewers)

  // console.log(applicant[0].email)
  // if(ralist === null){
  //   if(state.token != undefined)
  //     fetchRalist();
  // }
  
  return(
    <>
    {state.width < state.breakpoint ? 
      null
    :
      <Wrapper>
        <RaWrapper>
          
          {ra ?
            <ProfileForm>
              <ContentForm>
                {user.user["pk"] === ra.user["id"] &&
                <Link to={"/recruiter/raedit/" + ra.id}> 수정하기 </Link>
                }
                

                {ra.status !== "7%"&&
                  <div>
                    <h4>
                      회사
                    </h4>
                    <div>
                      {ra.company && 
                      ra.company.title
                      }
                      
                    </div>
                  </div>
                }
                

                <div>
                  <h4>
                    직군
                  </h4>
                  <div>
                    {ra.field}
                  </div>
                </div>

                <div>
                  <h4>
                    직무
                  </h4>
                  <div className={"ras-tag"}>
                    {ra.job.map((item)=>{
                      return(
                        <div>{item}</div>
                      )
                    })}
                  </div>
                </div>

                <div>
                  <h4>
                    요소기술
                  </h4>
                  <div className={"ras-tag"}>
                    {ra.abilities.map((item)=>{
                      return(
                        <div>{item}</div>
                      )
                    })}
                  </div>
                </div>

                <div>
                  <h4>
                    태그
                  </h4>
                  <div className={"ras-tag"}>
                    {ra.abilities.map((item)=>{
                      return(
                        <div>{item}</div>
                      )
                    })}
                  </div>
                </div>

                <div>
                  <h4>
                    도메인
                  </h4>
                  <div className={"ras-tag"}>
                    {ra.domain.map((item)=>{
                      return(
                        <div>{item}</div>
                      )
                    })}
                  </div>
                </div>

                <div>
                  <h4>
                    경력
                  </h4>
                  <div>
                    {ra.workyears}
                  </div>
                </div>
                
                <div>
                  <h4>
                    학위
                  </h4>
                  <div>
                    {ra.degree}
                  </div>
                </div>

                <div>
                  <h4>
                    예상연봉
                  </h4>
                  <div>
                    {ra.salary}
                  </div>
                </div>

                <div>
                  <h4>
                    마감일
                  </h4>
                  <div>
                    {ra.enddate}
                  </div>
                </div>

                <div>
                  <h4>
                    상태
                  </h4>
                  <div>
                    {ra.status}
                  </div>
                </div>

                <div>
                  <h4>
                    관리자연락처
                  </h4>
                  <div>
                    {ra.manager}
                  </div>
                </div>
                
                <div>
                  <h4>
                    근무지주소
                  </h4>
                  <div>
                    {ra.workadd}
                  </div>
                </div>
                <div className="devider"></div>
                <div>
                  <h4>
                    제목
                  </h4>
                  <div>
                    {ra.title}
                  </div>
                </div>

                <div>
                  <h4>
                    내용
                  </h4>
                  <div>
                    <ContentWrapper>
                      <div dangerouslySetInnerHTML={{__html: editorToHtml}}/>  
                    </ContentWrapper>
                  </div>
                </div>

                {/* <div>{ra.title}</div>
                <div>{ra.created.split('T')[0]}</div>
                <div>{ra.field}</div>
                <div>{ra.job}</div>
                <div>{ra.description}</div>
                <div>{ra.status}</div>
                <div>{ra.active}</div>
                <div>{ra.salary}</div>
                <div>{ra.workyears}</div>
                {applicant && applicant.map((item)=>{return(
                <div>{item.email}</div>
                )})} */}

              </ContentForm>
            </ProfileForm>
          :null}
          
        </RaWrapper>
        {ra && localStorage.getItem("is_headhunter") === "true" 
        && history.location.pathname.split('/').length === 6?
        <button
              onClick={()=> fetchPostRashop()}
        >장바구니</button>
        : null
        }
      </Wrapper>   
      }
    </>
  )
}



const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  margin-top: 45px;
  display: block;
  position: relative;
`

const RaWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: flex;
  margin: 0 auto;
  background-color: whitesmoke;
  flex-direction: column;
`


const ProfileForm = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 5px;
  padding-left: 0px;
  display: flex;
  margin: 0;
  /* flex-wrap: nowrap; */
  text-align: left;
  vertical-align: top;

  /* min-height: 300px; */

`

const ContentForm = styled.div`
    width: 100%;
    position: relative;
    display: block;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    box-sizing: border-box;
    padding: 10px;
    padding-left: 30px;
    padding-right: 30px;

    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px;
    border: .5px solid rgba(0,0,0,0.2);

    .devider{
      display: block;
      height: 1px;
      margin-top: 40px;
      border-top: 1px solid rgba(0,0,0,0.2);
    }

    >div{
      margin-bottom: 20px;
      h4{
        margin: 0;
        padding-top: 20px;
        padding-bottom: 10px;
      }
      >div{
        padding-left: 40px;
        font-size: 0.9rem;
        .basic-single{
          width: 200px;
        }

        .basic-multi{
          width: 200px;
        }
      }
      .ras-tag{
        >div{
          display: inline-block;
          font-size: 0.8rem;
          border: .5px solid rgba(0,0,0,0.2);
          border-radius: 12px;
          padding: 7px;
          padding-left: 10px;
          padding-right: 10px;
          margin: 5px;
          margin-left: 0;
          margin-right: 10px;
        }
      }
      .ras-work{
        margin-bottom: 10px;
        h4{
          font-size: 1rem;
          padding-top: 10px;
          padding-bottom: 5px;
        }
        .ras-work-memo{
          font-size: 1rem;
          margin-top: 10px;
          margin-bottom: 10px;
        }
        /* span{
          display: inline-flex;
          justify-content: center;
          align-items: center;
        } */
        ul{
          padding-left: 20px;
        }
      }
    }
`

const ContentWrapper = styled.div`
  display: block;
  /* margin-bottom: 20px; */
  >div{
    box-sizing: border-box;
    text-align: left;
    /* padding: 20px; */
    
  }
`


export default ComSingleRa